<template>
  <div class="pagination-summary">
    Displaying <b class="pagination-from">{{ from }}</b> - <b class="pagination-to">{{ Math.min(to, total) }}</b> out of <b class="pagination-total">{{ total }}</b>
  </div>
</template>

<script>
export default {
  name: 'PaginationSummary',
  props: {
    total: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    from() {
      return (this.page - 1) * this.perPage + 1;
    },
    to() {
      return this.page * this.perPage;
    },
  },
};
</script>

<style scoped>

</style>
